import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {FC, useState} from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { selectUsers, selectUsersError, selectUsersLoading } from "../../features/AppAuthSlice";
import LoadDataFromServerError from "../components/LoadDataFromServerError";
import LoadingErrorContent from "../components/LoadingErrorContent";
import RRFormLabel from "../components/RRFormLabel";
import { useAppSelector } from "../hooks";
import { showErrorsListInToast } from "../tools";
import { MaybeAppUserType } from "../types/AppUserType";
import { MaybeString } from "../types/Maybe";
import rightRentalLogo from "../../assets/images/right_rental_logo.png";
import redDevilLogo from "../../assets/images/reddevil-logo.png";
import kitchenLogo from "../../assets/images/kitchen_logo.png";

export interface LoginCredentials {
    email: string;
    password: string;
}

interface Props {
    loading: boolean;
    error?: string;
    onTryLogin: (credentials: LoginCredentials) => void;
}

const LoginView: FC<Props> = (props) => {
    const users = useAppSelector(selectUsers);
    const usersLoading = useAppSelector(selectUsersLoading);
    const usersError = useAppSelector(selectUsersError);

    const [user, setUser] = useState<MaybeAppUserType>(users[0]);
    const [password, setPassword] = useState<MaybeString>();

    const loginHandle = () => {
        if (!user || !password) {
            showErrorsListInToast("Внимание", ["Моля въведте парола и опитайте пак..."]);
        } else {
            const credentials: LoginCredentials = {
                email: user!.email,
                password: password!
            }
            props.onTryLogin(credentials);
        }
    }

    function submitFormHandle(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        loginHandle();
    }

    const today = new Date();

    return (
        <Modal show centered backdrop="static">
            <Modal.Header className={"justify-content-center"}>
                <Modal.Title>
                    <Row className={"m-2 p-2"}>
                        <Col className={"m-2 p-2 border rounded shadow"}><img src={rightRentalLogo} className={"w-100"} /></Col>
                        <Col className={"m-2 p-2 border rounded shadow"}><img src={redDevilLogo} className={"w-100"} /></Col>
                        <Col className={"m-2 p-2 border rounded shadow"}><img src={kitchenLogo} className={"w-100"} /></Col>
                    </Row>

                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <LoadingErrorContent loading={usersLoading} error={usersError}>
                    <Form onSubmit={e => submitFormHandle(e)}>
                        <Form.Group>
                            <RRFormLabel>Изберете потребител:</RRFormLabel>
                            <Form.Select disabled={props.loading}
                                         onChange={e => setUser(users.find(u => u.email === e.target.value))}>
                                <option></option>
                                {
                                    users
                                        .filter(user => !user?.validPeriod?.to || user.validPeriod.to > today )
                                        .map(
                                        value => <option key={value.email} value={value.email}>{value.name}</option>
                                    )
                                }
                            </Form.Select>
                        </Form.Group>
                        <Form.Group>
                            <RRFormLabel>Въведете парола:</RRFormLabel>
                            <Form.Control type="password" disabled={props.loading}
                                value={password || ""}
                                onChange={(e) => setPassword(e.target.value)} />
                        </Form.Group>
                        <Row className="mt-2">
                        {
                            props.error &&
                                <Col className="text-danger fw-bold text-center">
                                    <LoadDataFromServerError msg="Това не е валидна парола. Моля, опитайте пак..."  />
                                </Col>
                        }
                        {
                            props.loading &&
                                <Col className="fw-bold text-center">
                                    <Spinner />
                                </Col>
                        }
                            </Row>
                    </Form>
                </LoadingErrorContent>
            </Modal.Body>


            <Modal.Footer>
                <Col className="text-center">
                    {
                        users.length > 0 &&
                        <Button variant="outline-danger" onClick={loginHandle} disabled={props.loading}>
                            <FontAwesomeIcon icon={faUserLock} /> Вход
                        </Button>
                    }
                </Col>
            </Modal.Footer>
        </Modal >
    );
}

export default LoginView;
